/**
 * Composant SourceLegend
 * Affiche la légende des sources de données avec leurs couleurs associées
 */

interface SourceLegendProps {
  sources?: ('inrs' | 'anses' | 'echa' | 'agritox')[]
  compact?: boolean
  className?: string
}

const SOURCE_CONFIG = {
  inrs: { label: 'INRS', color: 'bg-orange-500' },
  anses: { label: 'ANSES', color: 'bg-green-500' },
  echa: { label: 'ECHA', color: 'bg-blue-500' },
  agritox: { label: 'AGRITOX', color: 'bg-violet-500' },
} as const

type SourceKey = keyof typeof SOURCE_CONFIG

export default function SourceLegend({
  sources,
  compact = false,
  className = '',
}: SourceLegendProps) {
  // Si aucune source spécifiée, afficher toutes les sources
  const displaySources: SourceKey[] = sources || ['inrs', 'anses', 'echa', 'agritox']

  if (compact) {
    // Mode compact : uniquement les dots avec tooltip
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        {displaySources.map((source) => (
          <span
            key={source}
            className={`w-2.5 h-2.5 rounded-full ${SOURCE_CONFIG[source].color}`}
            title={SOURCE_CONFIG[source].label}
          />
        ))}
      </div>
    )
  }

  // Mode standard : dots avec labels
  return (
    <div className={`flex items-center gap-4 text-sm text-gray-600 ${className}`}>
      {displaySources.map((source) => (
        <span key={source} className="flex items-center gap-1.5">
          <span className={`w-2.5 h-2.5 rounded-full ${SOURCE_CONFIG[source].color}`} />
          {SOURCE_CONFIG[source].label}
        </span>
      ))}
    </div>
  )
}
